export default class {
  constructor (symptomDetail = null) {
    this.symptomName = symptomDetail.symptomName
    this.status = symptomDetail.status
  }
}
